import user from './user'
import farm from './farm'
import server from './server'
import turbine from './turbine'
import reliability from './reliability'
import calculation from './calculation'
import data from './data'

export default { user, farm, server, turbine, reliability, calculation, data }
